(ns frontend.test.search-selector.sub
  (:require
   [re-frame.core :as rf]
   [frontend.test.search-selector.model :as m]))

(rf/reg-sub
 ;; Don't use directly - identity (:ident args) needed
 m/root-state
 (fn [db _]
   (get db m/root)))

(rf/reg-sub
 ;; State, specific to a single instance of this
 m/state
 (fn [[_ _args]]
   {:root-state (rf/subscribe [m/root-state])})
 (fn [{:keys [root-state]}
      [_ {:keys [ident]}]]
   (get-in root-state ident)))

(rf/reg-sub
 m/query
 (fn [[_ args]]
   (rf/subscribe [m/state args]))
 (fn [state _]
   (get state m/query-key)))

(rf/reg-sub
 m/results-query
 (fn [[_ args]]
   (rf/subscribe [m/state args]))
 (fn [state _]
   (get state m/results-query-key)))

(rf/reg-sub
 m/query-loading?
 (fn [[_ args]]
   (rf/subscribe [m/state args]))
 (fn [state _]
   (get state m/query-loading-key)))

(rf/reg-sub
 m/results-by-et
 (fn [[_ args]]
   (rf/subscribe [m/state args]))
 (fn [state _]
   (get state m/results-by-et-key)))
